
















import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import Input from './input'
import * as ruleNames from './constants/ruleNames'

@Component
export default class RadioInput extends mixins(Input) {
  @Prop(Array) options!: Array<{
    value: string | number
    label: string
  }>

  supportedRules: Array<string> = [ruleNames.REQUIRED]
}
